"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1() {
    return ((0, jsx_runtime_1.jsxs)(QnAWrapper, { children: [(0, jsx_runtime_1.jsx)(_1.QnAGuide, {}), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "question_new_wrapper" }, { children: (0, jsx_runtime_1.jsx)(_1.CommentForm, { commentId: "new-question" }) })), (0, jsx_runtime_1.jsx)(_1.QnAList, {})] }));
}
exports.default = default_1;
const QnAWrapper = styled_1.default.div `
  margin-bottom: 200px;
  background-color: white;
  #question_new_wrapper {
    padding: 20px 20px 5px;
    background-color: #f8f8f8;
  }
`;
